module.exports = __webpack_public_path__ + "img/pr-5.697ab712.png";